import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, Star, Users, UserPlus } from "lucide-react";
import api, { apiError } from "../../lib/api";

export default function ApprovalsTab() {
  const [data, setData] = useState({ reviews: [], teachers: [], students: [] });
  const load = () => api.get("/admin/approvals").then((r) => setData(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);
  const act = async (fn) => { try { const r = await fn(); toast.success(r.data.message); load(); } catch (e) { toast.error(apiError(e)); } };

  const Section = ({ title, Icon, items, testKey, render, approve, reject }) => (
    <section className="nb p-5">
      <h3 className="font-display font-extrabold flex items-center gap-2 mb-3"><Icon className="w-5 h-5" /> {title} <span className="nb-badge" style={{ background: items.length ? "#FCD34D" : "#F2FBE3" }}>{items.length} pending</span></h3>
      {items.length === 0 && <p className="text-sm text-slate-500">Nothing waiting for approval.</p>}
      <div className="space-y-2">
        {items.map((it) => (
          <div key={it.id} data-testid={`${testKey}-pending-${it.id}`} className="nb-flat p-3 flex flex-col sm:flex-row sm:items-center gap-3" style={{ borderRadius: 12 }}>
            <div className="flex-1 min-w-0 text-sm">{render(it)}<p className="text-[11px] text-slate-400 mt-1">{it.institution_name} · {(it.created_at || "").slice(0, 10)}</p></div>
            <div className="flex gap-2 shrink-0">
              <button data-testid={`${testKey}-approve-${it.id}`} onClick={() => act(() => approve(it))} className="nb-btn nb-btn-lime nb-btn-sm"><Check className="w-4 h-4" /> Approve</button>
              <button data-testid={`${testKey}-reject-${it.id}`} onClick={() => window.confirm("Reject and delete this entry?") && act(() => reject(it))} className="nb-btn nb-btn-sm"><X className="w-4 h-4" /> Reject</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );

  return (
    <div className="mt-8 space-y-6">
      <p className="text-sm text-slate-600">Reviews, teachers and students stay hidden from public profiles until approved here. Approving awards the configured points.</p>
      <Section title="Reviews" Icon={Star} items={data.reviews} testKey="review"
        render={(r) => <><p className="font-bold">{r.student_name} · {((r.teacher_quality + r.institute_quality + r.teaching_style + r.environment) / 4).toFixed(1)}★</p>{r.comment && <p className="text-slate-600">{r.comment}</p>}</>}
        approve={(r) => api.put(`/admin/reviews/${r.id}/approve`)} reject={(r) => api.delete(`/admin/reviews/${r.id}`)} />
      <Section title="Listed Teachers" Icon={UserPlus} items={data.teachers} testKey="teacher"
        render={(t) => <p className="font-bold">{t.name} <span className="font-normal text-slate-600">· {t.subject || "—"} · {t.phone}</span></p>}
        approve={(t) => api.put(`/admin/listed-teachers/${t.id}/verify`)} reject={(t) => api.delete(`/admin/listed-teachers/${t.id}`)} />
      <Section title="Listed Students" Icon={Users} items={data.students} testKey="student"
        render={(s) => <p className="font-bold">{s.name} <span className="font-normal text-slate-600">· {s.phone}{s.batch && ` · ${s.batch}`}</span></p>}
        approve={(s) => api.put(`/admin/listed-students/${s.id}/verify`)} reject={(s) => api.delete(`/admin/listed-students/${s.id}`)} />
    </div>
  );
}
